import { render, staticRenderFns } from "./service-garden-item.vue?vue&type=template&id=23d95efe"
import script from "./service-garden-item.vue?vue&type=script&lang=js"
export * from "./service-garden-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports